import './index.web.scss'

export { default as ProfileView } from './profile.web'
export * from './index.interface'
export * from './index.reducer'
export * from './index.saga'

export * from './ChangePassword/index.interface'
export * from './ChangePassword/index.reducer'
export * from './ChangePassword/index.saga'
export { default as ChangePasswordView } from './ChangePassword/index.web'

export { default as SetNewPasswordView } from './ForgotPassword/SetNewPassword.web'
export * from './ForgotPassword/forgotPassword.interface'
export * from './ForgotPassword/forgotPassword.reducer'
export * from './ForgotPassword/forgotPassword.saga'
export { default as ForgotPasswordView } from './ForgotPassword/index.web'

export * from './Login/index.interface'
export * from './Login/index.reducer'
export * from './Login/index.saga'
export { default as LoginView } from './Login/index.web'

export * from './Signup/index.interface'
export * from './Signup/index.reducer'
export * from './Signup/index.saga'
export { default as SignupView } from './Signup/signup'

export { default as AcceptInviteView } from './InviteUser/index.web'

export { default as PrivateRoute } from './privateRoute'
